declare namespace $ {

	type $mol_view__sub_shm_hitalama_process_monitor_branch_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_monitor_branch_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_expand__checked_shm_hitalama_process_monitor_branch_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor_branch['expanded'] >
		,
		ReturnType< $mol_check_expand['checked'] >
	>
	type $mol_check_expand__expandable_shm_hitalama_process_monitor_branch_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor_branch['expandable'] >
		,
		ReturnType< $mol_check_expand['expandable'] >
	>
	type $mol_check_expand__label_shm_hitalama_process_monitor_branch_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check_expand['label'] >
	>
	type $mol_list__rows_shm_hitalama_process_monitor_branch_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor_branch['content'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__render_visible_only_shm_hitalama_process_monitor_branch_7 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_list['render_visible_only'] >
	>
	type $mol_list__sub_visible_shm_hitalama_process_monitor_branch_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor_branch['content'] >
		,
		ReturnType< $mol_list['sub_visible'] >
	>
	export class $shm_hitalama_process_monitor_branch extends $mol_expander {
		Tools( ): any
		expanded( next?: boolean ): boolean
		expandable( ): boolean
		caption( ): string
		Caption( ): $mol_view
		content( ): readonly(any)[]
		render_visible_only( ): boolean
		Label( ): $mol_view
		Trigger( ): $mol_check_expand
		Content( ): $mol_list
	}
	
}

//# sourceMappingURL=branch.view.tree.d.ts.map